/**
 * DragScroll
 * Make an element scrollable by draging it with the mouse
 *
 * USAGE
 *   ds = new DragScroll(elem);
 *
 * PARAMS
 *   axis → defaults to both, if only one is needed, specify "x" or "y"
 *
 * METHODS
 *   ds.uninstall()
 *
 **/


export default class DragScroll {
  constructor(elem, axis) {
    this.elem = elem;
    this.axis = axis;
    this.pos = null;
    this._install();
  }

  _install() {
    this.elem.addEventListener('mousedown', this.on_mouse_down.bind(this), true);
    this.elem.addEventListener('mousemove', this.on_mouse_move.bind(this), true);
    window.addEventListener('mouseup', this.on_mouse_up.bind(this), true);
  }

  uninstall() {
    this.elem.removeEventListener('mousedown', this.on_mouse_down.bind(this), true);
    this.elem.removeEventListener('mousemove', this.on_mouse_move.bind(this), true);
    window.addEventListener('mouseup', this.on_mouse_up.bind(this), true);
    this.pos = null;
  }

  on_mouse_down(event) {
    this.pos = {
      left: this.elem.scrollLeft,
      top: this.elem.scrollTop,
      x: event.clientX,
      y: event.clientY,
    };
  }

  on_mouse_move(event) {
    if (this.pos === null)
      return;

    const dx = event.clientX - this.pos.x;
    const dy = event.clientY - this.pos.y;

    const options = {
      behavior: "instant", // auto, smooth, instant
    };
    if (!this.axis || this.axis == 'y')
      options.top = this.pos.top - dy;
    if (!this.axis || this.axis == 'x')
      options.left = this.pos.left - dx;

    this.elem.scroll(options);
  }

  on_mouse_up(event) {
    this.pos = null;
  }
}
